import { render, staticRenderFns } from "./selection-instructions.vue?vue&type=template&id=3cc3954b&"
import script from "./selection-instructions.vue?vue&type=script&lang=js&"
export * from "./selection-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports